import {getResource} from './BaseRequests'

export const fetchBrands = (success, fail) => {
    getResource("brands", {}, true).then(success).catch(fail)
}

export const fetchBrand = (id, success, fail) => {
    getResource("product", {id: id}, true).then(success).catch(fail)
}



//TODO: make this an option in devcore and pass it through with the products
export const getRestrictedBrands = [
  "Englefield",
  "St Michel",
  "Michel Cesar",
  "VCBC",
  "Robertson",
  "Hangrohe",
  "Axor",
  "Jeka",
  "Atlantis",
  "Atlantis Showers",
  "Aquatica",
  "Escea",
  "Feltex",
  "Feltex Carpets",
  "Godfrey Hirst",
  "Robert Malcolm",
  "ELFA",
  "Wardrobes Direct",
  "Kitchen Contours",
  "Trethewey Granite Benchtops",
  "Trethewey Stone",
  "Dekton",
  "Dekton Benchtops",
  "Caesarstone",
  "Caesarstone Benchtops",
  "ColorIt Splashbacks",
  "French Country",
  "Warwick",
  "Maurice Kain",
  "Resene Curtain Fabrics",
  "Resene Curtains",
  "Uniquartz - Unique Surfaces",
  "Uniquartz",
  "Silestone",
  "Laminate Benchtops",
  "Splashbacks",
  "Parmco",
]

// Same Jank as Above
export const getFlyoverBrands = [
	'Aarke',
	'Advantage',
	'Advocate',
	'Aspiring Walls',
	'Athena',
	'Award',
	'Baby Bundles',
	'Baby First',
	'Baby Jogger',
	'Baby Organics',
	'Beef Eater',
	'Beko',
	'Billybeds',
	'Black Hawk',
	'Bonds',
	'Ecostore',
	'Englefield',
	'Escea',
	'Eve Wallace',
	'Evenflo',
	'Fairydown',
	'Fisher & Paykel',
	'Furniture by Design',
	'Gasmate',
	'GHD',
	'Globewest',
	'Greenies',
	'Greens',
	'Kong',
	'Lamaze',
	'LG',
	'Lillebaby',
	'Linens and More',
	'Little Big Paw',
	'Little Innocents',
	'Living Nature',
	'Love to Dream',
	'Love to Swaddle',
	'Massport',
	'Masterpet',
	'Maytime',
	'Methven',
	'Mitsubishi',
	'Mokopuna',
	'Mountain Buggy',
	'Mum 2 Mum',
	'Nespresso',
	'Nutrience ',
	'Nutro',
	'Panasonic',
	'Petware',
	'Phil & Teds',
	'Phillips',
	'Plantaion Bamboo',
	'Plumbline',
	'Promate',
	'Remington',
	'Resene ',
	'Royal Canin',
	'Samsung',
	'Science Diet',
	'Silly Billyz',
	'Silver Spas',
	'SleepMaker',
	'Sleepsystems',
	'Soren Liv',
	'St Michel',
	'Sukin',
	'Tile Trends',
	'Trilogy',
	'Victa',
	'Warwick',
	'Weleda',
	'Weleda',
	'Westinghouse',
]

export const fetchNZBrands = (success, fail) => {
	let brandsIDs = [
		"49003",
		"49086",
		"303647",
		"49110",
		"286981",
		"336174",
		"50252",
		"110770",
		"49431",
		"335796",
		"168897",
		"49587",
		"50248",
		"411365",
		"344442",
		"285067",
		"49855",
		"277604",
		"50745",
		"50040",
		"283407",
		"344486",
		"50384",
		"302801",
		"202797"
	];

	new Promise((res) => {
		let brands = [];
		for (let index = 0; index < brandsIDs.length; index++) {
			fetchBrand(brandsIDs[index], (response) => {
				brands[index] = response;
			},
			(err) => {
				console.log(err)
			})
			
		}
		res(brands)
	})
		.then(success)
		.catch(fail)
}